import firebase from 'infrastructure/firebase'
import { useAtom, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { Button } from '@mui/material'
import React, { FunctionComponent, ReactNode } from 'react'
import {
  internalGoogleUserAtom,
  googleLoginError,
  GoogleUserAtomValue,
} from './googleAuth.atoms'

const DEFAULT_SCOPES = ['https://www.googleapis.com/auth/drive']

export function GoogleLoginButton({
  hideWhenLoggedIn,
  ParentComponent,
  LoggedInComponent,
  scopes = DEFAULT_SCOPES,
}: {
  hideWhenLoggedIn?: boolean
  ParentComponent?: FunctionComponent<{ children: ReactNode }>
  LoggedInComponent?: FunctionComponent<{ user: firebase.User }>
  scopes?: string[]
}) {
  const errorSetter = useSetAtom(googleLoginError)
  const [session, sessionSetter] = useAtom(internalGoogleUserAtom)

  const login = async () => {
    const provider = new firebase.auth.GoogleAuthProvider()
    for (const scope of scopes) {
      provider.addScope(scope)
    }

    const result = (await firebase
      .auth()
      .signInWithPopup(provider)
      .catch((error) => {
        errorSetter(error)
      })) as GoogleUserAtomValue
    sessionSetter(result)
  }

  if (
    session &&
    session.user &&
    session.credential?.accessToken &&
    (hideWhenLoggedIn || LoggedInComponent)
  )
    return LoggedInComponent ? <LoggedInComponent user={session.user} /> : null

  const theButton = (
    <Button variant="contained" color="primary" onClick={login}>
      Authorize Google
    </Button>
  )

  if (ParentComponent) {
    return <ParentComponent>{theButton}</ParentComponent>
  }

  return theButton
}
